<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TkUf8i/images/image-9781614179795.jpg?1684514596039" alt="This image is the cover for the book Spirits United (A Daisy Gumm Majesty Mystery, Book 12), Daisy Gumm Majesty Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spirits United (A Daisy Gumm Majesty Mystery, Book 12), Daisy Gumm Majesty Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>There's a Body in the Stacks and Wedding Bells in the Air in SPIRITS UNITED, A Historical Cozy Mystery from Alice Duncan</b><br/><br/><i>--1920s Pasadena, California--</i><br/><br/>It's 1924 and spiritualist-medium Daisy Gumm and her fiancé, Detective Sam Rotondo, discover a dead body tucked away in the Pasadena Public Library's bibliography stacks.<br/><br/>Worse, Daisy's old friend, Mr. Browning, is holding the bloody knife, putting him at the very top of Sam's suspect list.<br/><br/>But Daisy isn't convinced and sets out to exonerate her friend, only to stumble into a professor's geological study, encounter a mad scientist, and uncover a phony gold rush that someone is killing to hide.<br/><br/><b>"Well plotted with a band of whimsical characters and genuine humor . . ."</b> <i>~Diane Morasco, RT Book Reviews</i><br/><br/><b>THE DAISY GUMM MAJESTY MYSTERIES</b><br/><i>Strong Spirits<br/>Fine Spirits<br/>High Spirits<br/>Hungry Spirits<br/>Genteel Spirits<br/>Ancient Spirits<br/>Spirits Revived<br/>Dark Spirits<br/>Spirits Onstage<br/>Unsettled Spirits<br/>Bruised Spirits<br/>Spirits United<br/>Spirits Unearthed<br/>Shaken Spirits<br/><br/></i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alice Duncan
      </h2>
      
      <p class="authorDescription body article">In an effort to avoid what she knew she should be doing, Alice folk-danced professionally until her writing muse finally had its way. Now a resident of Roswell, New Mexico, Alice enjoys saying no smog, no crowds, and yes to loving her herd of wild dachshunds. Visit Alice at www.aliceduncan.net.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Works!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d37c7b8c